import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote, Star } from "lucide-react";
import RevealText from "../components/RevealText";
import { BRAND } from "../lib/brand";

// Placeholder - Teresa provides the Google Form link
const REVIEW_FORM_URL = "https://forms.gle/uuYgzXP1uzR64bZ48";

// Reviews ricevute da Teresa
const REVIEWS = [
  {
    name: "Una mamma",
    role: "Recensione",
    text: "Molto preparata e professionale, amorevole e dolce. La migliore tata per la mia bambina.",
    stars: 5,
  },
  {
    name: "Genitori di Matteo",
    role: "Cura Educativa · 5–11 mesi",
    text: "Teresa è stata con il nostro bimbo Matteo per oltre 6 mesi, accompagnandolo nella crescita dai 5 agli 11 mesi. Fin dal primo giorno si è dimostrata professionale, competente e incredibilmente premurosa. Nostro figlio è sempre stato sereno e felice in sua compagnia. In questi mesi è cresciuto tantissimo, anche grazie agli stimoli, attività e insegnamenti proposti da Teresa. Il suo supporto è stato prezioso anche per noi: sempre disponibile al confronto, ci ha dato suggerimenti utili — dai giochi ai massaggi, dallo svezzamento alla nanna. Le saremo sempre affezionati e riconoscenti.",
    stars: 5,
  },
  {
    name: "Mamma di una bimba di 1 anno e mezzo",
    role: "Consulenze evolutive",
    text: "Teresa è sempre gentilissima e disponibile. Durante le fasi di crescita di mia figlia mi ha sempre dato ottimi consigli. È stata d'aiuto nella gestione dei momenti di gioco, della motricità e delle interazioni. Ha spesso intuito con un ottimo tempismo momenti salienti della sua crescita: quando passare dal seno al biberon, quando era pronta per mangiare da sola, quando per gattonare e camminare. Il suo supporto è gentile e mai invasivo.",
    stars: 5,
  },
  {
    name: "Mamma di una bimba di 5 anni",
    role: "Rapporto continuativo",
    text: "Mia figlia, ormai di cinque anni, conosce Teresa da quando aveva pochi mesi. Affidare mia figlia alle sue cure è stato per me come madre un grande supporto da tutti i punti di vista. Professionalità e gioia di lavorare raramente si incontrano.",
    stars: 5,
  },
  {
    name: "Genitori · Festa 6 anni",
    role: "Compleanno",
    text: "Ho contattato Teresa in occasione del sesto compleanno di mio figlio. Grazie alla sua professionalità e disponibilità abbiamo concordato le proposte di gioco e organizzato la festa in base ai desideri del bimbo. Il risultato è stato assolutamente divertente e coinvolgente. Esperienza positiva e consigliata.",
    stars: 5,
  },
  {
    name: "Un'allieva",
    role: "Corso sul Sonno",
    text: "Con Teresa ho deciso di intraprendere il corso sul sonno, per me molto importante. È stato veramente molto interessante, utile e formativo. Lo ritengo un corso completo.",
    stars: 5,
  },
  {
    name: "Una mamma",
    role: "Massaggio Infantile",
    text: "Gentile, professionale ed estremamente preparata. Con Teresa abbiamo fatto il percorso di massaggio infantile e fin dal primo incontro è stato meraviglioso. Paziente e rispettosa dei tempi del bambino, sempre disponibile anche a distanza per consigli o dubbi. Veramente una persona preziosa.",
    stars: 5,
  },
  {
    name: "Una mamma",
    role: "Rapporto di famiglia",
    text: "Conosco Teresa ormai da tanti anni, è diventata praticamente di famiglia! Posso dire che mi ha supportata tanto nel mio percorso genitoriale, e la madre che sono oggi lo devo anche a lei.",
    stars: 5,
  },
  {
    name: "Nonna di un bimbo di 1 anno",
    role: "Cura Educativa",
    text: "È stata la tata del mio nipotino di 1 anno. È stata una grandissima fortuna conoscerla e apprezzarla per l'altissima professionalità e per come il piccolo è cresciuto mentalmente in modo incredibile. L'attaccamento del piccolo verso di lei dimostra il lavoro svolto: senza forzature ma con una tecnica di accrescimento bellissima. Grande professionista ma soprattutto grande tata, con tanta pazienza e sensibilità.",
    stars: 5,
  },
  {
    name: "Mamma di due bimbi",
    role: "\"La Dada n° 1\"",
    text: "La Dada n° 1!!! Dopo anni, ancora i miei bimbi chiedono di lei. Per il più piccolo, ogni momento passato con la dada è un regalo stupendo e cerco di accontentarlo, soprattutto utilizzando i pomeriggi con la dada come premio! Grazie Dada ♥️",
    stars: 5,
  },
  {
    name: "Genitori",
    role: "Compleanno bimba",
    text: "Abbiamo contattato Teresa per organizzare il compleanno di nostra figlia. È stata molto cordiale e ha fatto un gran lavoro di organizzazione e allestimento della sala, preoccupandosi di ogni minimo particolare. Dopo tutto il lavoro di preparazione ha passato le ore con i bimbi a fare il trucco per la festa. Consigliatissima.",
    stars: 5,
  },
  {
    name: "Un'allieva",
    role: "Corso sul Sonno",
    text: "Ho seguito con Teresa il corso sul sonno. Un corso fantastico, molto formativo, utile e completo. Teresa è una bravissima professionista, una persona sempre disponibile, sempre pronta a darti ottimi consigli e a supportarti.",
    stars: 5,
  },
  {
    name: "Mamma di un bimbo di 8 mesi",
    role: "Consulenza",
    text: "La prima consulenza è stata per caso ma si è rivelata una vera scoperta. Il mio bambino di 8 mesi è un po' pigro e grazie ai consigli di Teresa siamo riusciti a trovare un'altra strada per spronarlo a fare sempre di più. Poco per volta ma con sicurezza e tranquillità. Sarà sicuramente un punto di riferimento per i prossimi passi.",
    stars: 5,
  },
  {
    name: "Un'allieva",
    role: "Formazione",
    text: "Con Teresa ho deciso di approfondire il tema dell'infanzia, per me molto importante. Sono pienamente soddisfatta delle nozioni che ho acquisito. È stato veramente molto formativo e anche molto interessante.",
    stars: 5,
  },
];

export default function DiconoDiMe() {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const bearY = useTransform(scrollYProgress, [0, 1], ["0%", "70%"]);
  const bearRotate = useTransform(scrollYProgress, [0, 1], [0, 25]);

  return (
    <div data-testid="dicono-di-me-page">
      {/* HERO */}
      <section ref={heroRef} className="relative min-h-[70vh] pt-32 md:pt-40 pb-12 px-6 md:px-10 overflow-hidden">
        <div className="max-w-[1600px] mx-auto relative">
          <p className="text-[10px] uppercase tracking-[0.4em] text-[#FF2768] mb-4">— Recensioni</p>
          <h1 className="font-display text-[14vw] md:text-[11vw] lg:text-[14rem] leading-[0.82] text-[#3D2140]">
            <RevealText text={["Dicono", <span key="1" className="text-[#FF2768]">di me.</span>]} stagger={0.14} />
          </h1>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-12 gap-8">
            <p className="md:col-span-6 md:col-start-4 font-editorial text-2xl md:text-3xl text-[#3D2140] leading-snug italic">
              Le parole dei genitori e delle tate che ho avuto la fortuna di accompagnare. Il regalo più bello di questo lavoro.
            </p>
          </div>
        </div>

        <motion.img
          src={BRAND.logo}
          alt=""
          aria-hidden
          style={{ y: bearY, rotate: bearRotate }}
          className="absolute right-4 md:right-16 top-24 md:top-40 h-32 md:h-52 w-32 md:w-52 rounded-full opacity-80"
        />
      </section>

      {/* REVIEWS GRID */}
      <section className="px-6 md:px-10 py-16 md:py-24 max-w-[1600px] mx-auto" data-testid="reviews-grid">
        {REVIEWS.length === 0 ? (
          <div className="text-center py-16 md:py-24 border border-dashed border-[#81C3C9]/50 rounded-[32px] bg-white/50">
            <Quote size={40} className="mx-auto text-[#FF2768]/40 mb-6" />
            <p className="font-editorial text-2xl md:text-3xl text-[#3D2140]/70 italic max-w-xl mx-auto leading-snug">
              Presto qui troverai le testimonianze di chi ha camminato accanto a me. Se hai una storia da condividere, sarà preziosa.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {REVIEWS.map((r, idx) => (
              <motion.article
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: (idx % 3) * 0.08 }}
                className={`p-8 rounded-[28px] bg-white border border-[#81C3C9]/40 relative ${idx % 3 === 1 ? "lg:mt-10" : idx % 3 === 2 ? "lg:mt-6" : ""}`}
                data-testid={`review-${idx}`}
              >
                <Quote size={28} className="text-[#FF2768]/70 mb-4" />
                {r.stars && (
                  <div className="flex gap-1 mb-4">
                    {Array.from({ length: r.stars }).map((_, i) => (
                      <Star key={i} size={14} className="fill-[#FFE45C] text-[#FFE45C]" />
                    ))}
                  </div>
                )}
                <p className="text-[#3D2140] leading-relaxed text-lg mb-6 font-editorial italic">"{r.text}"</p>
                <div className="pt-4 border-t border-[#81C3C9]/30">
                  <p className="font-display text-2xl text-[#3D2140]">{r.name}</p>
                  {r.role && <p className="text-sm text-[#FF2768] uppercase tracking-wider">{r.role}</p>}
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </section>

      {/* LEAVE A REVIEW CTA */}
      <section className="px-6 md:px-10 py-24 md:py-32 bg-[#3D2140] text-white relative overflow-hidden" data-testid="leave-review-section">
        <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-[#FF2768]/20 blur-3xl pointer-events-none" />
        <div className="absolute -right-24 -bottom-24 h-96 w-96 rounded-full bg-[#81C3C9]/20 blur-3xl pointer-events-none" />
        <img src={BRAND.logo} alt="" aria-hidden className="absolute right-6 md:right-16 bottom-6 md:bottom-16 h-32 md:h-48 w-32 md:w-48 rounded-full opacity-60 animate-floaty" />
        <div className="max-w-[1400px] mx-auto relative">
          <p className="text-[10px] uppercase tracking-[0.4em] text-[#FFE45C] mb-6">— Hai lavorato con me?</p>
          <h2 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] mb-8 max-w-4xl">
            Lascia la tua<br/><span className="text-[#FF2768]">recensione.</span>
          </h2>
          <p className="max-w-2xl text-white/80 text-lg md:text-xl leading-relaxed mb-10 font-editorial italic">
            La tua voce è preziosa. Racconta la tua esperienza in poche righe: aiuterà altre famiglie e altre tate a scegliere con fiducia.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={REVIEW_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-form-cta"
              className="btn-tv-primary"
            >
              Compila il modulo <ArrowRight size={16} />
            </a>
            <a href={BRAND.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-7 py-[14px] rounded-full border border-white/40 text-white hover:bg-white hover:text-[#3D2140] transition-all">
              Scrivimi su WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
